'use strict';

exports.__esModule = true;

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _beeTable = require('bee-table');

var _beeTable2 = _interopRequireDefault(_beeTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

//import renderContainer from '../containers/renderContainer';


var TableRender = _react2['default'].createClass({
  displayName: 'TableRender',

  propTypes: {
    /**
     * callback sub component onClick event
     */
    onClickItem: _react.PropTypes.func
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onClick: _lodash.noop,
      onClickItem: _lodash.noop
    };
  },
  render: function render() {
    var _props = this.props,
        children = _props.children,
        tableColumns = _props.tableColumns;

    children.forEach(function (item, index) {
      item.key = index + 1 + '';
    });

    return _react2['default'].createElement(
      'div',
      { className: 'col-md-12' },
      _react2['default'].createElement(_beeTable2['default'], {
        useFixedHeader: true,
        scroll: { x: true, y: 400 },
        emptyText: function emptyText() {
          return '加载中...';
        },
        columns: tableColumns,
        data: children,
        onRowClick: this._handleClick
      })
    );
  },
  _handleClick: function _handleClick(record, index, e) {
    var _props2 = this.props,
        disabled = _props2.disabled,
        onClickItem = _props2.onClickItem;

    e.preventDefault();
    !disabled && onClickItem(record);
  }
});

// const TableRender = renderContainer(BaseTableRender);

// export {BaseTableRender};
exports['default'] = TableRender;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/ssc-refer/lib/refer/TableRender.react.js
// module id = 579
// module chunks = 0